
// TODO: Only import used icons
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';


import '@/games/sanjuan';



import Vue from 'vue'
import VueRouter from 'vue-router';

//
// V-viewer
//
// https://github.com/mirari/v-viewer
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
Vue.use(Viewer);


//
// Vue router
//
Vue.use(VueRouter);

import MainPage from './vue/pages/Main.vue'
import GamePage from './vue/pages/Game.vue'
import MultiplayerPage from './vue/pages/Multiplayer.vue'


const routes = [
    {
        path: '/',
        component: MainPage
    },
    { path: '/game', name:'game', component: GamePage },
    { path: '/multiplayer', component: MultiplayerPage },
    { path: '/multiplayer/:game_id', component: MultiplayerPage },
];

const router = new VueRouter({
    routes
});


Vue.config.productionTip = false

new Vue({
    router,
}).$mount('#app-root');
